import React from 'react'
import { redirect } from 'next/navigation'
import { navigationProfile } from '@/features/profile-page/TabBarProfile/navigationStorage.jsx'
import { useDispatch } from 'react-redux'
import ProfileChapter from '@/features/profile-page/ProfileChapter'
import HistoryOrders from '@/features/profile-page/HistoryOrders'
import HistoryTransactions from '@/features/profile-page/HistoryTransactions'
import SettingsProfile from '@/features/profile-page/SettingsProfile'
import { useGetIsAuthUser } from '@/shared/hooks/useGetIsAuthUser.js'
import {
    useClearCartMutation,
    useGetCountProductsQuery,
} from '@/shared/api-rtk/api-list/cartApi'
import { reset } from '@/shared/store/slice/cartSlice'
import { useGetCartItemsQuery } from '@/shared/api-rtk'

export const TabBarProfile = () => {
    const navigate = (path) => redirect(path)
    const { logoutUser } = useGetIsAuthUser()
    const [showItems, setShowItems] = React.useState(navigationProfile[0])
    const { refetch: refetchCount } = useGetCountProductsQuery()
    const { refetch: refetchProductsInCart } = useGetCartItemsQuery()

    const dispatch = useDispatch()

    const handleLogout = async () => {
        await logoutUser()
        await refetchCount()
        await refetchProductsInCart()
        navigate('/')
        dispatch(reset())
    }

    return (
        <div className={'TabBarProfile'}>
            <nav>
                {navigationProfile.map((item, index) => (
                    <button
                        key={index}
                        disabled={showItems === item || item.text === 'История транзакций'}
                        onClick={() => setShowItems(item)}
                        className={item.text === 'История транзакций' ? 'no-active' : ''}
                    >
                        {item.img}
                        {item.text}
                    </button>
                ))}
                <button onClick={handleLogout}>
                    <img src="/icons/logout.svg" alt="logout-icon" />
                    Выход
                </button>
            </nav>
            <main className={'content-profile'}>
                {showItems === navigationProfile[0] && <ProfileChapter />}
                {showItems === navigationProfile[1] && <HistoryOrders />}
                {showItems === navigationProfile[2] && <HistoryTransactions />}
                {showItems === navigationProfile[3] && <SettingsProfile />}
            </main>
        </div>
    )
}